module.exports = __webpack_public_path__ + "static/media/copy.52a11c9b.svg";